import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';

const API = '/api/tikoo/auth';

export default function ResetPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const [organizerName, setOrganizerName] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`${API}/verify-reset-token/${token}`)
      .then(res => { setOrganizerName(res.data.name); setStatus('valid'); })
      .catch(() => setStatus('invalid'));
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) { setError('Passwords do not match'); return; }
    if (password.length < 6) { setError('Password must be at least 6 characters'); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/reset-password`, { token, password });
      setStatus('success');
      toast.success('Password reset successfully!');
      setTimeout(() => navigate('/organizer/login'), 2500);
    } catch (err) {
      setError(err.response?.data?.error || 'Reset failed. The link may have expired.');
    } finally {
      setLoading(false);
    }
  };

  const bg = { minHeight: '100vh', background: 'linear-gradient(135deg,#1A2744,#2D3A5F)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 };
  const card = { background: '#fff', borderRadius: 20, padding: 40, maxWidth: 420, width: '100%', textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' };

  if (status === 'verifying') return (
    <div style={bg}><div style={{ color: '#fff', textAlign: 'center' }}><p>Verifying your reset link...</p></div></div>
  );

  if (status === 'invalid') return (
    <div style={bg}><div style={card}>
      <div style={{ fontSize: 64, marginBottom: 16 }}>⏰</div>
      <h2 style={{ fontSize: 22, marginBottom: 12, color: '#1A2744' }}>Link Expired</h2>
      <p style={{ color: '#6B7280', marginBottom: 24 }}>This reset link is invalid or has expired. Please request a new one.</p>
      <Link to="/organizer/forgot-password" style={{ display: 'block', background: '#E8521A', color: '#fff', padding: '12px 0', borderRadius: 10, textDecoration: 'none', fontWeight: 700, marginBottom: 12 }}>Request New Link</Link>
      <Link to="/organizer/login" style={{ color: '#9CA3AF', fontSize: 14 }}>Back to Sign In</Link>
    </div></div>
  );

  if (status === 'success') return (
    <div style={bg}><div style={card}>
      <div style={{ fontSize: 64, marginBottom: 16 }}>✅</div>
      <h2 style={{ fontSize: 22, marginBottom: 12, color: '#1A2744' }}>Password Reset!</h2>
      <p style={{ color: '#6B7280' }}>Your password has been updated. Redirecting to login...</p>
    </div></div>
  );

  return (
    <div style={bg}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <img src="https://omogusiiwarriors.org/icons/logo.png" alt="OWW" style={{ width: 70, height: 70, objectFit: 'contain', marginBottom: 12 }} />
          <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 24, color: '#fff', margin: '0 0 4px' }}>Tikoo Organizer</h1>
          {organizerName && <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 14, marginTop: 4 }}>Hello, {organizerName}</p>}
        </div>
        <div style={{ background: '#fff', borderRadius: 20, padding: 40, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
          <h2 style={{ fontSize: 20, marginBottom: 20, color: '#1A2744' }}>Create New Password</h2>
          {error && <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 8, padding: '10px 14px', marginBottom: 16, color: '#DC2626', fontSize: 14 }}>⚠️ {error}</div>}
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>New Password</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPass ? 'text' : 'password'}
                  placeholder="Minimum 6 characters"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                  style={{ width: '100%', padding: '12px 44px 12px 14px', border: '1px solid #D1D5DB', borderRadius: 8, fontSize: 15, boxSizing: 'border-box' }}
                />
                <button type="button" onClick={() => setShowPass(!showPass)} style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 16 }}>
                  {showPass ? '🙈' : '👁️'}
                </button>
              </div>
              {password && (
                <div style={{ marginTop: 6 }}>
                  <div style={{ height: 4, background: '#f3f4f6', borderRadius: 2, overflow: 'hidden' }}>
                    <div style={{ height: '100%', borderRadius: 2, transition: 'width 0.3s', width: password.length >= 10 ? '100%' : password.length >= 7 ? '60%' : '30%', background: password.length >= 10 ? '#2D7D32' : password.length >= 7 ? '#F59E0B' : '#DC2626' }} />
                  </div>
                  <span style={{ fontSize: 11, color: password.length >= 10 ? '#2D7D32' : password.length >= 7 ? '#F59E0B' : '#DC2626' }}>
                    {password.length >= 10 ? 'Strong' : password.length >= 7 ? 'Medium' : 'Weak'}
                  </span>
                </div>
              )}
            </div>
            <div style={{ marginBottom: 24 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Confirm Password</label>
              <input
                type="password"
                placeholder="Repeat new password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                required
                style={{ width: '100%', padding: '12px 14px', border: `1px solid ${confirm && confirm !== password ? '#DC2626' : '#D1D5DB'}`, borderRadius: 8, fontSize: 15, boxSizing: 'border-box' }}
              />
              {confirm && confirm !== password && <p style={{ color: '#DC2626', fontSize: 12, marginTop: 4 }}>Passwords don't match</p>}
            </div>
            <button type="submit" disabled={loading}
              style={{ width: '100%', background: '#E8521A', color: '#fff', padding: 14, borderRadius: 10, border: 'none', fontWeight: 700, fontSize: 16, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>
              {loading ? '⏳ Resetting...' : '🔐 Set New Password'}
            </button>
          </form>
          <p style={{ textAlign: 'center', marginTop: 20, fontSize: 14, color: '#6B7280' }}>
            <Link to="/organizer/login" style={{ color: '#E8521A', fontWeight: 600 }}>← Back to Sign In</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
